export default "__VITE_ASSET__kZGtRi4w__"